import React from "react";
import styled from "styled-components";

import Contain from "./contain";
import Title from "./title";
import Portal from "./portal";

const Section = styled.section`
  padding: 5rem 0 8rem;

  h2 {
    max-width: 44rem;
    margin: 0 auto 2.5rem;
  }
`;

const Description = styled.div`
  max-width: 40rem;
  margin: 0 auto 2.5rem;
  font-size: 1.1rem;
  font-weight: 500;
  line-height: 1.6;
  text-align: center;

  strong {
    text-decoration: underline;
  }
`;

const Row = styled.div`
  @media (min-width: 50rem) {
    display: flex;
  }
`;

const Column = styled.div`
  padding: 2rem;
  background: #fff;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.05), 0 -8px 16px rgba(0, 0, 0, 0.05);

  @media (min-width: 50rem) {
    width: 360px;
    margin: 0 auto;
  }

  ${(props) =>
    props.main &&
    `
    background: #FFFAF0;
    position: relative;
  `}
`;

const Ul = styled.ul`
  margin-bottom: 1.5rem;
`;

const Li = styled.li`
  background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M20.485 3.515A11.922 11.922 0 0012 0a11.921 11.921 0 00-8.485 3.515A11.921 11.921 0 000 12c0 3.205 1.248 6.219 3.515 8.485A11.921 11.921 0 0012 24c3.205 0 6.219-1.248 8.485-3.515A11.921 11.921 0 0024 12c0-3.205-1.248-6.219-3.515-8.485zM12 22.594C6.159 22.594 1.406 17.84 1.406 12 1.406 6.159 6.16 1.406 12 1.406c5.841 0 10.594 4.753 10.594 10.594 0 5.841-4.753 10.594-10.594 10.594z' fill='%233182CE'/%3E%3Cpath d='M17.733 8.15a.703.703 0 00-.995 0l-6.209 6.209-3.268-3.269a.703.703 0 00-.995.995l3.766 3.765a.7.7 0 00.994 0l6.707-6.706a.703.703 0 000-.994z' fill='%233182CE'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: left top;
  padding: 0 0 0.5rem 2rem;
  font-weight: 500;
`;

const Plan = styled.div`
  font-weight: 600;
  letter-spacing: 0.1rem;
  margin-bottom: 1.5rem;
  text-transform: uppercase;
`;

const Amount = styled.div`
  color: #2d3748;
  margin-bottom: 1.5rem;

  span {
    font-size: 2rem;
    font-weight: 600;
  }

  small {
    font-weight: 500;
    color: #718096;
    font-size: 1rem;
  }
`;

const Option = styled.div`
  font-size: 1.1rem;
  font-weight: 500;
  margin: 0 0 2rem;

  a {
    text-decoration: underline;
  }
`;

const PlanDescription = styled.div`
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #2d3748;
`;

const ButtonCTA = styled.a`
  color: #fff !important;
  padding: 0.5rem 1rem;
  line-height: 1 !important;
  transition: 150ms;
  transition-timing-function: ease-in-out;
  font-weight: 500 !important;
  background: #0070e0;
  font-size: 1.1rem !important;
  padding: 0.8rem 1rem;
  background: linear-gradient(96.06deg, #e53e3e 0.73%, #f56565 99.49%);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 50px;

  &:hover {
    color: #fff !important;
    background: linear-gradient(96.06deg, #e53e3e 0.73%, #f56565 99.49%);
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.15);
  }
`;

export default class Pricing extends React.Component {
  state = {
    annual: false,
    visible: false,
    registerUrl:
      "https://quickpageapp.com/register?p=plan_HBi0YdaHYZYTWP&qpc=kwrur&qp_i=real-estate&qp_hau=kwrur",
    ref: null,
  };

  render() {
    const { registerUrl } = this.state;
    return (
      <Section id="pricing">
        <Contain small>
          <Title textCenter>
            Get the world’s #1 sales application at an unbeatable value
          </Title>
          <Description>
            We make it easy to sign up and start sending video messages today.
          </Description>
          <Row>
            <Column main>
              <Plan>Quickpage Individual</Plan>
              <Amount>
                <span>$0/month</span>{" "}
                <small>first 4 months free. $29/month after</small>
              </Amount>
              <Ul>
                <Li>Unlimited Customer Pages</Li>
                <Li>4000 Contacts</Li>
                <Li>Mobile app for Apple & Android</Li>
                <Li>Facebook Support & Training</Li>
              </Ul>
              <ButtonCTA href={registerUrl}>Get started now</ButtonCTA>
            </Column>
          </Row>
        </Contain>
      </Section>
    );
  }
}
